var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipseBigHalf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 534,
    viewBox: "0 0 252 534",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.61 143.17C232.2 180.182 221.22 222.309 221.22 267C221.22 311.691 232.2 353.818 251.61 390.83C206.976 475.939 117.769 534 15 534C-132.46 534 -252 414.46 -252 267C-252 119.54 -132.46 0 15 0C117.769 0 206.976 58.0611 251.61 143.17ZM15 409.033C-63.4424 409.033 -127.033 345.442 -127.033 267C-127.033 188.558 -63.4424 124.967 15 124.967C93.4424 124.967 157.033 188.558 157.033 267C157.033 345.442 93.4424 409.033 15 409.033Z",
    fill: "#3F81BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseBigHalf);
export default __webpack_public_path__ + "static/media/ellipse_big_half.03e5fcf5dba50125a232cd0aeec14781.svg";
export { ForwardRef as ReactComponent };